export default __webpack_public_path__ + "static/part-hawk-349f26716b7771dd66210c85c8bdf363.png";